const $window = $(window);

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

//ヘッダー開閉
import {headerToggle} from "../include/module";
headerToggle();

import {scrollAnimation} from "../include/module";

//動画モーダル
import {showMovie} from "../include/module";
showMovie();

$(window).on('load', function(){
  setTimeout(function () {
    scrollAnimation();
  }, 100);
});

$(window).on('scroll', function(){
  scrollAnimation();
});

/*-------------------------------------------------------------------*/
/* swiper */
/*-------------------------------------------------------------------*/
const modal_swiper = () => {
  var galleryThumbs = new Swiper('.swiper-thumbs', {
    // spaceBetween: 10,
    // slidesPerView: 10,
    // freeMode: true,
    // watchSlidesProgress: true,
    watchSlidesVisibility: true,
    allowTouchMove: false,
  });
  var galleryTop = new Swiper('.swiper-Img', {
    // spaceBetween: 10,
    loop: false,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
      swiper: galleryThumbs
    }
  });
}

// const showModal = () => {
//   $('body').on('click', '.modal_template', function(){
//     // const dataModal = $(this).attr('data-modal');
//     const dataModal = $(this).children('template');
//     console.log(dataModal);
//     const clone = dataModal.clone(true);
//     // div#containerの中に追加
//     $('#test').append(clone);
//   });
// }
// showModal();

const showModal = () => {
    // ボタンのDOM要素を取得
  var template = document.getElementsByClassName('modal_template');
  for (var i = template.length - 1; i >= 0; i--) {
    template[i].addEventListener("click", function(){
      var template_content = this.querySelector('template');
      var clone = template_content.content.cloneNode(true);
      document.getElementById('showModal').appendChild(clone);
      setTimeout(function () {
        modal_swiper();
        closeModal();
        $('body').css({'overflow':'hidden'});
      }, 100);
    });
  }
}
showModal();

const closeModal = () => {
  if($('#showModal').find('.goods_modal')){
    $('#showModal .goods_modal .goods_modal_Overlay, #showModal .goods_modal .btn').on('click', function(){
      // console.log('find');
      $('body').css({'overflow':'auto'});
      $('#showModal .goods_modal').remove();
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/goods/script.js